export const HKD_CURRENCY = 'HKD'
export const FALLBACK_EXCHANGE_RATE = 1

export const normalizeExchangeRateMap = (inputRates) => {
  const baseMap = { [HKD_CURRENCY]: 1 }
  if (!inputRates || typeof inputRates !== 'object') {
    return baseMap
  }

  return Object.entries(inputRates).reduce((acc, [currency, rate]) => {
    const numericRate = parseFloat(rate)
    if (Number.isFinite(numericRate) && numericRate > 0) {
      acc[currency] = numericRate
    }
    return acc
  }, baseMap)
}

export const getExchangeRateToHKD = (currency, exchangeRateMap = {}) => {
  if (currency === HKD_CURRENCY) {
    return 1
  }

  const exchangeRate = parseFloat(exchangeRateMap?.[currency])
  return Number.isFinite(exchangeRate) && exchangeRate > 0 ? exchangeRate : FALLBACK_EXCHANGE_RATE
}
